import React from 'react';
import { Badge } from './ui/badge';
import { getFromLocalStorage } from '../mock';

// CRITICAL: Always use same-origin (relative URL) for API calls.
// The reverse proxy routes /api/* to the backend on both production and preview.
// Using process.env.REACT_APP_BACKEND_URL caused intermittent failures because
// the build-time env var pointed to platform-internal hosts (e.g. automod-tracker.emergent.host)
// that become unreachable during container recycles.
export const BACKEND_URL = '';

export const getAuthHeaders = () => {
  const token = getFromLocalStorage('accessToken');
  return { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` };
};

export const STATUS_MAP = {
  beklemede: ['Beklemede', 'bg-gray-500'], randevu_planlandi: ['Randevu Planlandı', 'bg-indigo-500'],
  arac_kabul: ['Araç Kabul', 'bg-cyan-600'], islemde: ['İşlemde', 'bg-blue-500'],
  kalite_kontrol: ['Kalite Kontrol', 'bg-yellow-600'], teslime_hazir: ['Teslime Hazır', 'bg-green-500'],
  teslim_edildi: ['Teslim Edildi', 'bg-gray-700'], pending: ['Beklemede', 'bg-gray-500'],
  in_progress: ['İşlemde', 'bg-blue-500'], ready: ['Teslime Hazır', 'bg-green-500'],
  completed: ['Teslim Edildi', 'bg-gray-700'],
};

export const getStatusBadge = (status) => {
  const [label, cls] = STATUS_MAP[status] || STATUS_MAP.beklemede;
  return <Badge className={`${cls} text-white`}>{label}</Badge>;
};

export const PORTAL_STATUS_MAP = {
  draft: ['Email Yok', 'bg-gray-600', 'Portal erisimi yok'],
  invitation_pending: ['Davet Bekliyor', 'bg-yellow-600', 'Aktivasyon maili gonderilmedi'],
  activation_email_sent: ['Mail Gonderildi', 'bg-blue-600', 'Aktivasyon maili gonderildi'],
  active: ['Portal Aktif', 'bg-green-600', 'Giris yapabilir'],
};

export const getPortalBadge = (customer) => {
  const status = customer?.portalStatus || 'draft';
  const [label, cls] = PORTAL_STATUS_MAP[status] || PORTAL_STATUS_MAP.draft;
  return <Badge className={`${cls} text-white text-[10px]`} data-testid={`portal-status-${status}`}>{label}</Badge>;
};
